import { useContext } from 'react';
import { SnackBarContext } from 'providers/SnackBarProvider';

const useSnackBar = () => useContext(SnackBarContext);

export default useSnackBar;
